import { refreshRecentOpenBoard } from '../authUser/recentBoards/refreshRecentOpenBoard';
import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardSetName } from './boardSetName';
import { getBoard } from 'app/store/model/selectors/getBoardById';
import Util from '../../../util/util';
import { fetchHandler } from '../../../util/fetchHandler';
import { IRestDashboard } from '../../../types/rest/IRestDashboard';
import { boardsActionSet } from '../../../store/model/actions/boardsActionSet';
import { boardActionSet } from '../../../store/model/boards/actions/boardActionSet';
import { updateAction } from '../../../store/model/board/actions/updateAction';

export const updateBoardName = (
    boardId: TBoardId,
    name: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const board = getBoard(getState(), boardId);
        if (board && board.name && board.name === name) return Promise.reject();

        return dispatch(boardSetName(boardId, name)).then(() => {
            dispatch(refreshRecentOpenBoard(boardId));
        }).then(() =>{
            const url = Util.getApiUrl('/rest/dashboards/' + boardId);
            fetchHandler<IRestDashboard>(
                url
            ).then((restBoard)=>{
                dispatch(boardsActionSet(boardActionSet(boardId, updateAction({
                    cardFromEmail: restBoard.cardFromEmail,
                }))));
            })
        })
    };
    return action;
};
